import type { ElementType } from 'react'

import Card from 'js/components/Card'
import cx from 'js/lib/helpers/cx'

import styles from './Wrapper.module.css'

type WrapperProps = {
    as?: ElementType
    className?: string
} & Record<string, any>

const Wrapper = ({ className, ...rest }: WrapperProps) => (
    <Card className={cx(styles.wrapper, className)} {...(rest as any)} />
)

export default Wrapper
